import React, { useState } from 'react';
import { StarIcon, PhoneIcon } from 'lucide-react';
import { ContactModal } from './ContactModal';
export function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-108" />
      <section className="relative min-h-[90vh] flex items-center" style={{
      backgroundColor: '#eae8d6'
    }} data-id="element-109">
        {/* Full-bleed background */}
        <div className="absolute inset-0" data-id="element-110">
          <img src="https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=1920&q=80" alt="HVAC technician working on vents" className="w-full h-full object-cover object-center" data-id="element-111" />
          <div className="absolute inset-0 bg-navy" style={{
          opacity: 0.82
        }} data-id="element-112"></div>
          <div className="absolute inset-0 bg-texture-diagonal opacity-40" data-id="element-113"></div>
        </div>

        {/* Warm glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-orange rounded-full opacity-5 blur-3xl pointer-events-none" data-id="element-114"></div>

        {/* Main content */}
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full py-8 md:py-12 text-center" data-id="element-115">
          {/* 5-Star badge */}
          <div className="inline-flex items-center gap-2 mb-8" data-id="element-116">
            <div className="flex text-orange" data-id="element-117">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-118" />)}
            </div>
            <span className="text-cream/80 font-sub tracking-widest text-sm uppercase" data-id="element-119">
              5-Star Rated Local Business
            </span>
          </div>

          <h1 className="text-6xl md:text-8xl text-cream font-display leading-[1.05] drop-shadow-2xl uppercase mb-8" data-id="element-120">
            OLD-FASHIONED{' '}
            <span className="text-orange" style={{
            textShadow: '3px 3px 0px rgba(0,0,0,0.3)'
          }} data-id="element-121">
              SERVICE.
            </span>
            <br data-id="element-122" />
            MODERN{' '}
            <span className="text-orange" style={{
            textShadow: '3px 3px 0px rgba(0,0,0,0.3)'
          }} data-id="element-123">
              HOME AIR.
            </span>
          </h1>

          <p className="text-xl text-blue-100 max-w-2xl mx-auto font-body leading-relaxed mb-10" data-id="element-124">
            Honest, hard-working HVAC experts who treat you like family. No
            gimmicks, just quality work done right the first time.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-125">
            {/* Mobile: direct call */}
            <a href="tel:6025842141" className="sm:hidden bg-orange text-white px-8 py-4 rounded-sm font-sub text-xl uppercase tracking-wide shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] flex items-center justify-center gap-2" data-id="element-126">
              <PhoneIcon className="h-5 w-5" data-id="element-127" />
              Call Now: 602-584-2141
            </a>
            {/* Desktop: open modal */}
            <button onClick={() => setIsModalOpen(true)} className="hidden sm:flex bg-orange hover:bg-orange-600 text-white px-8 py-4 rounded-sm font-sub text-xl uppercase tracking-wide shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all items-center justify-center gap-2" data-id="element-128">
              <PhoneIcon className="h-5 w-5" data-id="element-129" />
              Call Now: 602-584-2141
            </button>
            <a href="#services" className="bg-transparent border-2 border-cream text-cream hover:bg-cream hover:text-navy px-8 py-4 rounded-sm font-sub text-xl uppercase tracking-wide transition-all flex items-center justify-center gap-2" data-id="element-130">
              Our Services
            </a>
          </div>
        </div>

        {/* Roadrunner mascot — tail overlaps into services section */}
        <img src="https://cdn.magicpatterns.com/uploads/uo4dEMA5t29hfmaxf5VVx6/state_48_mascot.webp" alt="State 48 Roadrunner Mascot" className="absolute bottom-0 right-8 w-48 md:w-64 h-auto drop-shadow-2xl z-20 opacity-80" data-id="element-131" />

        {/* Diagonal tan divider — fills bottom-left triangle */}
        <div className="absolute bottom-0 left-0 right-0 z-10" style={{
        height: '80px',
        background: '#eae8d6',
        clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 0 100%)'
      }} data-id="element-132"></div>

        {/* Hard tan seal — covers any sub-pixel gap at the very bottom */}
        <div className="absolute bottom-0 left-0 right-0 z-10" style={{
        height: '4px',
        background: '#eae8d6'
      }} data-id="element-133"></div>
      </section>
    </>;
}